import React from 'react';
import styled from '../../theme';
import { JustifyContentProperty, AlignItemsProperty } from 'csstype';

interface IProps extends React.HTMLAttributes<HTMLElement> {
  justify?: JustifyContentProperty;
  align?: AlignItemsProperty;
  /* A CSS margin value. The minimum space between the clustered child elements. */
  space?: string;
}

const StyledCluster = styled.div<IProps>(
  (props) => `
  & > * {
    display: flex;
    flex-wrap: wrap;
    justify-content: ${props.justify};
    align-items: ${props.align};
    margin: calc(${props.space} / 2 * -1);
  }

  & > * > * {
    margin: calc(${props.space} / 2);
  }
`,
);

const Cluster: React.FC<IProps> = ({ justify = 'center', align = 'center', space = '0.5rem', children, ...rest }) => {
  const props = {
    justify,
    align,
    space,
  };
  return (
    <StyledCluster {...rest} {...props}>
      <div>{children}</div>
    </StyledCluster>
  );
};

export default Cluster;
